console.log("init Proteus treatments -- 2.07")

// remove discount line-item prop 
observeSelector('input[name="properties[Discount]"]', prop => {
  prop.remove();
})

observeSelector('[class*="rebuy"], [id*="rebuy"], [src*="rebuy.js"]', rebuy => {
  rebuy.remove();
})

const modify_sub = async (selling_plan_id, element, percentage_off = "") => {
  
  let line_key = element.getAttribute("key");
  let qty = parseInt(element.getAttribute("qty"));
  let var_id = element.getAttribute("var_id");

  console.log("adjust_sub()", line_key, qty, var_id, selling_plan_id);

  if (!line_key || !var_id || !selling_plan_id || !qty) return;

  try {
    // 1️⃣ Remove existing line
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: line_key,
        quantity: 0,
      }),
    });

    let props = {};
    if(percentage_off != ""){
      props = {"Discount": `${percentage_off}% Off`};
    }

    // 2️⃣ Add same variant with selling plan
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: var_id,
        quantity: qty,
        selling_plan: selling_plan_id,
        properties: props
      }),
    });

    // document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
    document.documentElement.dispatchEvent(new CustomEvent('cart:build', {
      bubbles: true
    }));

  } catch (err) {
    console.error("Subscription swap failed", err);
  }
};

const remove_cart_line = async (element) => {
  
  let line_key = element.getAttribute("key");
  console.log('remove_cart_line()', line_key);

  if (!line_key) return;

  try {
    // 1️⃣ Remove existing line
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: line_key,
        quantity: 0,
      }),
    });

    // document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
    document.documentElement.dispatchEvent(new CustomEvent('cart:build', {
      bubbles: true
    }));

  } catch (err) {
    console.error("remove_cart_line failed", err);
  }
};

observeSelector('.cart_item_selling_plan', selling_plan => {

  selling_plan.addEventListener("change", (e) => {
    let selling_plan_id = e.target.value;
    let percentage_off = e.target.querySelector("option").getAttribute("plan_value");
    modify_sub(selling_plan_id, e.target, percentage_off);
  });

});

observeSelector('.js-convert-to-sub', convert_to_sub => {

  convert_to_sub.addEventListener("click", (e) => {
    let selling_plan_id = convert_to_sub.getAttribute("plan_id");
    let percentage_off = convert_to_sub.getAttribute("plan_value");
    modify_sub(selling_plan_id, e.target, percentage_off);
  });

})

observeSelector('.js-remove-item', remove_item => {
  remove_item.addEventListener("click", (e) => {
    remove_cart_line(e.target);
  });

});

// upgrade modal
let open_modal = (product_data) => {
  
  waitForElement('body').then(doc => {
    doc.setAttribute("data-js-modal", "active");    
    if(document.querySelectorAll('.js-modal.js-modal--upgrade').length == 0){

      doc.insertAdjacentHTML("afterbegin", `
        <style>
          body:not([data-js-modal="active"]) .js-modal--overlay,
          body:not([data-js-modal="active"]) .js-modal{
            display: none;
          }
          .js-modal--overlay{
            position: fixed;
            width: 100vw;
            height: 100vw;
            top: 0;
            left: 0;
            background: #000000aa;
            backdrop-filter: blur(5px);
            z-index: 999;
          }
          .js-modal{
            position: fixed; 
            z-index: 9999;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: #fff;
            padding: 2rem;
            max-width: 90%;
            min-width: 400px;
          }
          .js-modal--content a,
          .js-modal--content input{
            display: block;
            border-radius: 10px;
            padding: .5rem;
            font-size: 1.15rem;
          }

          .js-modal--content input{
            padding: .35rem;
            border: 1px solid;
            width: 100%;
            margin: 1.5rem 0 .5rem 0;
          }

          .js-modal--close{
            cursor: pointer;
            font-size: 2em;
            position: absolute;
            top: 0;
            right: 0;
            height: 0;
            line-height: 0;
            padding: 1rem;
          }

        </style>
        <div class="js-modal--overlay"></div>
        <div class="js-modal js-modal--upgrade">
          <div class="js-modal--content">
            <div class="js-modal--close">&times;</div>
            <h3 class="h3" style="margin-bottom: .5rem;">Switch to a subscription</h3>
            <h4 class="h4" style="margin-bottom: .5rem;">Subscribe and save up to 20% on every delivery</h4>
            <p>Flexible—pause, cancel, or customize anytime.</p>
            
            /*
            <img src="${window.product_data.img_url}" />
            ${window.product_data.title}
            ${window.product_data.reviews_html}
            ${window.product_data.price}
            ${window.product_data.compare_at}
            */

            <a class="button button--xl" href="#">Continue</a>
          </div>
        </div>
      `)

      waitForElement('.js-modal--overlay').then(overlay => {
        overlay.addEventListener("click", () => {
          doc.removeAttribute("data-js-modal");
        })
      }).catch();

      waitForElement('.js-modal--close').then(overlay => {
        overlay.addEventListener("click", () => {
          doc.removeAttribute("data-js-modal");
        })
      }).catch();

      waitForElement('.js-modal--upgrade a').then(button => {
        waitForElement('.js-modal--upgrade form').then(form => {
          button.addEventListener("click", (e) => {
            e.preventDefault();
            check_email();
          })
          form.addEventListener("submit", (e) => {
            e.preventDefault();
            check_email();
          })
        })
      }).catch();

    }
  }).catch();
}

document.addEventListener("proteus:cart-changed", async (e) => {
  const hasSellingPlan = e.detail.items.some(item =>
    item.selling_plan_allocation
  );
  if(hasSellingPlan){
  // if(hasSellingPlan && !window.sessionStorage.getItem("sub_popup_shown")){
    window.sessionStorage.setItem("sub_popup_shown", true)
    // open_modal(window.product_data);
  }
});

// START [PUR-13]
function activatePC13() {
  const CLINICIAN_COUNTS = {
    2186: '728', // purity-protect-coffee-pods
    2189: '728', // original-roast-coffee-sachets
    2181: '728', // balance-caff-single-serve-purity-pods
    2177: '728', // balance-whole-bean-coffee
    2187: '728', // balance-caff-single-serve-pocket-purity
    2185: '710', // dark-roast-roast-coffee-pods
    2188: '728', // decaf-coffee-sachets
    2178: '728', // decaf-whole-bean-coffee
    2182: '728', // balance-caff-ground-coffee
    2179: '728', // original-roast-whole-bean-coffee
    2184: '728', // calm-decaf-ground-coffee
    2183: '728', // decaf-coffee-pods
    2180: '704', // dark-roast-whole-bean-coffee
  };

  function buildReplica(clinicianCount) {
    const style = document.createElement('style');
    style.id = 'pc13-frontrow-styles';
    style.textContent = `
      #pc13-frontrow-widget {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 12px;
        padding: 8px 10px 10px 8px;
        border: 1px solid #888;
        box-shadow: 1px 1px 5px #ddd;
        border-radius: 3px;
      }
      #pc13-frontrow-widget .fr-heading {
        display: flex;
        align-items: center;
        gap: 4px;
        flex-shrink: 0;
      }
      #pc13-frontrow-widget .fr-heading p {
        font-family: 'Lora', serif;
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        letter-spacing: 0.2px;
        text-align: center;
        color: #212121;
        margin: 0;
      }
      #pc13-frontrow-widget .fr-heading svg {
        height: 35px;
        width: auto;
      }
      #pc13-frontrow-widget .fr-heading svg path {
        stroke: transparent;
        fill: #212121;
      }
      #pc13-frontrow-widget .fr-body {
        display: flex;
        flex-direction: column;
        gap: 6px;
        flex: 1;
        text-align: left;
      }
      #pc13-frontrow-widget .fr-copy {
        font-size: 13px;
        font-weight: 400;
        line-height: 18px;
        color: #212121;
        margin: 0;
      }
      #pc13-frontrow-widget .fr-copy .fr-bold {
        font-weight: 600;
      }
      #pc13-frontrow-widget .fr-copy .fr-italics {
        font-style: italic;
      }
      #pc13-frontrow-widget .fr-cta {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 6px;
      }
      #pc13-frontrow-widget .fr-avatars {
        display: flex;
        align-items: center;
        height: 18px;
      }
      #pc13-frontrow-widget .fr-avatars img {
        width: 16px;
        height: 16px;
        border-radius: 100px;
        object-fit: cover;
        border: 2px solid #FFF;
        background-color: #eee;
        position: relative;
      }
      #pc13-frontrow-widget .fr-avatars img:nth-of-type(2),
      #pc13-frontrow-widget .fr-avatars img:nth-of-type(3) {
        margin-left: -10px;
      }
      #pc13-frontrow-widget .fr-learn-more {
        font-size: 13px;
        font-weight: 400;
        line-height: 18px;
        color: #212121;
        background: none;
        border: none;
        padding: 0;
        cursor: pointer;
        text-decoration: underline;
        text-underline-offset: 4px;
        text-decoration-thickness: 1px;
        text-decoration-color: #212121;
        margin-top: -2px;
      }
      #pc13-frontrow-widget .fr-learn-more:hover {
        opacity: 0.8;
      }
      @media screen and (max-width:768px) {
        #pc13-frontrow-widget {
          gap: 8px;
          padding: 5px;
        }
        #pc13-frontrow-widget .fr-heading p {
          font-size: 12px;
          line-height: 17px;
        }
        #pc13-frontrow-widget .fr-heading svg {
          height: 25px;
        }
        #pc13-frontrow-widget .fr-copy, #pc13-frontrow-widget .fr-learn-more {
          font-size: 11px;
          line-height: 16px;
        }
      }
    `;
    document.head.appendChild(style);

    const wrapper = document.createElement('div');
    wrapper.id = 'pc13-frontrow-widget';
    wrapper.innerHTML = `
      <div class="fr-heading">
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="35" viewBox="0 0 17 35" fill="none">
          <path d="M2.60396 10.0782C2.63019 12.7275 5.0681 14.8472 5.0681 14.8472C5.0681 14.8472 7.46457 12.6717 7.43993 10.0222C7.41325 7.3697 4.97398 5.25178 4.97398 5.25178C4.97398 5.25178 2.57932 7.42863 2.60396 10.0782ZM1.34556 19.1722C2.78927 21.3977 5.99278 21.9007 5.99278 21.9007C5.99278 21.9007 6.85625 18.7951 5.41254 16.5696C3.96883 14.3441 0.763495 13.8397 0.763495 13.8397C0.763495 13.8397 -0.0997442 16.9469 1.34556 19.1722ZM3.82901 27.3622C6.16621 28.6381 9.23028 27.5709 9.23028 27.5709C9.23028 27.5709 8.50337 24.4335 6.16618 23.1576C3.82898 21.8817 0.764911 22.9489 0.764911 22.9489C0.764911 22.9489 1.49182 26.0862 3.82901 27.3622ZM10.5368 33.3638C13.0903 34.1327 15.868 32.4611 15.868 32.4611C15.868 32.4611 14.504 29.5425 11.9502 28.772C9.39665 28.0031 6.62082 29.6761 6.62082 29.6761C6.62082 29.6761 7.98323 32.5949 10.5368 33.3638ZM9.02056 3.29033C7.3448 5.35644 7.8659 8.53241 7.8659 8.53241C7.8659 8.53241 11.1079 8.36114 12.7836 6.29503C14.4594 4.22891 13.9381 1.05136 13.9381 1.05136C13.9381 1.05136 10.6963 1.22421 9.02056 3.29033Z" stroke="#212121" stroke-linecap="round"/>
        </svg>
        <p>Clinicians'<br>Choice</p>
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="35" viewBox="0 0 17 35" fill="none">
          <path d="M14.1756 10.0782C14.1494 12.7275 11.7114 14.8472 11.7114 14.8472C11.7114 14.8472 9.31497 12.6717 9.33961 10.0222C9.36629 7.3697 11.8056 5.25178 11.8056 5.25178C11.8056 5.25178 14.2002 7.42863 14.1756 10.0782ZM15.434 19.1722C13.9903 21.3977 10.7868 21.9007 10.7868 21.9007C10.7868 21.9007 9.92329 18.7951 11.367 16.5696C12.8107 14.3441 16.016 13.8397 16.016 13.8397C16.016 13.8397 16.8793 16.9469 15.434 19.1722ZM12.9505 27.3622C10.6133 28.6381 7.54926 27.5709 7.54926 27.5709C7.54926 27.5709 8.27617 24.4335 10.6134 23.1576C12.9506 21.8817 16.0146 22.9489 16.0146 22.9489C16.0146 22.9489 15.2877 26.0862 12.9505 27.3622ZM6.24277 33.3638C3.68923 34.1327 0.911591 32.4611 0.911591 32.4611C0.911591 32.4611 2.27559 29.5425 4.82935 28.772C7.38289 28.0031 10.1587 29.6761 10.1587 29.6761C10.1587 29.6761 8.79631 32.5949 6.24277 33.3638ZM7.75898 3.29033C9.43474 5.35644 8.91365 8.53241 8.91365 8.53241C8.91365 8.53241 5.67166 8.36114 3.9959 6.29503C2.32014 4.22891 2.84146 1.05136 2.84146 1.05136C2.84146 1.05136 6.08322 1.22421 7.75898 3.29033Z" stroke="#212121" stroke-linecap="round"/>
        </svg>
      </div>
      <div class="fr-body">
        <p class="fr-copy">
          <span class="fr-bold">${clinicianCount} clinicians</span> share this
          on <span class="fr-italics">FrontrowMD</span> without compensation.
        </p>
        <div class="fr-cta">
          <div class="fr-avatars">
            <img src="https://assets.app.thefrontrowhealth.com/jijjnma3wz2ktevmvpuoewdnubm0" alt="Dr. Kimberly Rogers, MD">
            <img src="https://assets.app.thefrontrowhealth.com/4e8he28d9xopj5iyyv83w41q78xi" alt="Brittany Reynolds, NP">
            <img src="https://assets.app.thefrontrowhealth.com/pa8nliuewz7t7g0dmxjawwf0kr5a" alt="Dr. Green">
          </div>
          <button class="fr-learn-more" onclick="window.postMessage('OPEN_MODAL_STICKER', '*')" aria-label="Click to learn more about the clinicians sharing this product">
            View clinicians &amp; learn more
          </button>
        </div>
      </div>
    `;

    const starRating = document.querySelector('[id*="okendo_star_rating"]');
    const iframe = document.getElementById('frontrow-sticker');

    if (starRating) {
      starRating.insertAdjacentElement('afterend', wrapper);
    }
    if (iframe) {
      iframe.remove();
    }
  }

  const existingIframe = document.getElementById('frontrow-sticker');
  if (existingIframe) {
    const src = existingIframe.src;
    const productId = src && parseInt(new URL(src).searchParams.get('product_id'), 10);
    const count = CLINICIAN_COUNTS[productId] ?? '700+';
    buildReplica(count);
  } else {
    const observer = new MutationObserver(() => {
      const iframe = document.getElementById('frontrow-sticker');
      if (iframe) {
        observer.disconnect();
        const src = iframe.src;
        const productId = src && parseInt(new URL(src).searchParams.get('product_id'), 10);
        const count = CLINICIAN_COUNTS[productId] ?? '700+';
        buildReplica(count);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
}
// END [PUR-13]

// START [PUR-11]
observeSelector('input[skio-selling-plan-group]', sub => {
  
  sub.checked = true;
  sub.dispatchEvent(
    new Event("change", { bubbles: true })
  );

});

observeSelector('.pc-option-block.pc-sub', pc_07_sub => {
  pc_07_sub.click();
});
// end [PUR-11]


// =============================================================================
// PURITY COFFEE – Custom Product Selection UI
// =============================================================================
// This script creates a custom purchase option UI that integrates with the
// Skio subscription plan picker web component via its Shadow DOM.
//
// Product variants are fetched dynamically from Shopify's AJAX API
// (/products/{handle}.js). Size options are auto-generated from variant
// titles — no variant IDs or weights need to be hardcoded.
//
// Each size card maps 1:1 to a real Shopify variant.
//
// DEPENDENCIES from proteus-utils (must be loaded before this script):
//   - waitForElement(selector)   → Promise that resolves when element exists
//   - waitUntil(conditionFn)     → Promise that resolves when condition is truthy
// =============================================================================


// =============================================================================
// SETTINGS
// =============================================================================

const SETTINGS = {
  // -- Experiment / Logging --------------------------------------------------
  experimentId: "PC-07",
  version: "v1",
  logPrefix: "Purity Treatments",
  logVersion: "1.07",

  // -- Activation -------------------------------------------------------------
  // This script does NOT run automatically. It exposes a global function
  // that must be called by an external script (e.g., an A/B test platform)
  // to activate the treatment.
  //
  // Usage from external script:
  //   window.activatePC07()
  //
  // The function returns a promise that resolves when the UI is injected.

  // -- Product Filter ---------------------------------------------------------
  // List of product handles to activate on. The handle is the last part of
  // the product URL: /products/{handle}
  //
  // If this array is empty, the script runs on ALL product pages.
  // If it has entries, the script ONLY runs on those products.
  //
  // Examples:
  //   []                                          → runs everywhere
  //   ["original-roast-whole-bean-coffee"]         → runs on one product
  //   ["original-roast-whole-bean-coffee", "dark-roast-whole-bean-coffee"] → two products

  productHandles: ["original-roast-whole-bean-coffee", "dark-roast-whole-bean-coffee", "decaf-whole-bean-coffee", "purity-protect", "balance-whole-bean-coffee"],

  // -- Serving Size -----------------------------------------------------------
  gramsPerCup: 13.34,

  // -- Unit Conversions -------------------------------------------------------
  ouncesToGrams: 28.3495,
  poundsToGrams: 453.592,

  // -- Bundle Options ---------------------------------------------------------
  // Synthetic bundles that add multiple units of a base variant.
  // Not real Shopify variants — they add qty units of the base variant to cart.
  //
  // baseVariantIndex: position in productOptions after sorting (0 = smallest/base)
  // qty: quantity to add to cart (visually supports 2 or 3)
  // discountPct: percentage discount on the bundle
  // badge: optional badge text, ie. "Most Popular" (null for none)

  bundles: [
    {
      baseVariantIndex: 0,
      qty: 3,
      discountPct: 0.069,
      badge: null,
    },
  ],

  // -- Subscribe Discount -----------------------------------------------------
  subscribeDiscountPct: 0.20,

  // -- Frequency Options ------------------------------------------------------
  frequencies: {
    "2w":  { weeks: 2,  label: "Every 2 Weeks",  sellingPlanId: "1493434537" },
    "4w":  { weeks: 4,  label: "Every 4 Weeks",  sellingPlanId: "1493467305" },
    "6w":  { weeks: 6,  label: "Every 6 Weeks",  sellingPlanId: "1493500073" },
    "8w":  { weeks: 8,  label: "Every 8 Weeks",  sellingPlanId: "1493532841" },
    "10w": { weeks: 10, label: "Every 10 Weeks", sellingPlanId: "1493565609" },
    "12w": { weeks: 12, label: "Every 12 Weeks", sellingPlanId: "1493598377" },
  },

  // -- Frequency Assignment Rules ---------------------------------------------
  frequencyRules: [
    {
      minGrams: 0,
      maxGrams: 400,
      frequencyKeys: ["4w", "6w", "8w"],
    },
    {
      minGrams: 401,
      maxGrams: 1200,
      frequencyKeys: ["4w", "6w", "8w"],
    },
    {
      minGrams: 1201,
      maxGrams: Infinity,
      frequencyKeys: ["4w", "8w", "12w"],
    },
  ],

  // -- Badge Rules ------------------------------------------------------------
  badgeRules: [
    { minGrams: 2000, maxGrams: Infinity, badge: "Best Value" },
  ],

  // -- Brand Colors -----------------------------------------------------------
  brandPrimary: "#0f0f0f",     // off black — borders, text, badges
  brandAccent: "#008075",      // teal — sale prices, highlights
  brandBackground: "#f8f8f8",  // light gray — selected state background
};


// =============================================================================
// HELPER — Fetch product data from Shopify AJAX API
// =============================================================================

async function fetchShopifyProduct() {
  const pathParts = window.location.pathname.split("/").filter(Boolean);
  const productsIndex = pathParts.indexOf("products");
  if (productsIndex === -1 || productsIndex >= pathParts.length - 1) {
    return null;
  }
  const handle = pathParts[productsIndex + 1];

  try {
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return await res.json();
  } catch (err) {
    console.error(`[${SETTINGS.experimentId}] Failed to fetch product data:`, err);
    return null;
  }
}


// =============================================================================
// HELPER — Parse weight from variant title
// =============================================================================

function parseWeightFromTitle(title) {
  if (!title) return null;

  const match = title.match(/(\d+(?:\.\d+)?)\s*(oz|lb|lbs|ounce|ounces|pound|pounds)/i);
  if (!match) return null;

  const value = parseFloat(match[1]);
  const unit = match[2].toLowerCase();

  if (unit === "oz" || unit === "ounce" || unit === "ounces") {
    return {
      weightOz: value,
      weightLbs: null,
      weightGrams: value * SETTINGS.ouncesToGrams,
      sizeLabel: `${value}oz`,
    };
  }

  if (unit === "lb" || unit === "lbs" || unit === "pound" || unit === "pounds") {
    return {
      weightOz: null,
      weightLbs: value,
      weightGrams: value * SETTINGS.poundsToGrams,
      sizeLabel: `${value}lb`,
    };
  }

  return null;
}

function calcTotalGrams(option) {
  if (option.weightLbs) return option.weightLbs * 453.592;
  return (option.weightOz || 0) * 28.3495;
}

function calcCups(option) {
  const singleUnitGrams = calcTotalGrams(option);
  const cupsPerUnit = Math.floor(singleUnitGrams / 13.34);
  return cupsPerUnit * option.qty;
}

function calcCupsPerDayLabel(option, frequencyWeeks) {
  const cups = calcCups(option);
  const days = frequencyWeeks * 7;
  const cupsPerDay = cups / days;

  if (cupsPerDay >= 1.8) return `~${Math.round(cupsPerDay)} cups / day`;
  if (cupsPerDay >= 0.8) return `~1 cup / day`;
  if (cupsPerDay >= 0.45) return `1 cup every other day`;
  const daysPerCup = Math.round(1 / cupsPerDay);
  return `1 cup every ~${daysPerCup} days`;
}


// =============================================================================
// HELPER — Auto-build product options from variants
// =============================================================================

function buildProductOptions(shopifyProduct) {
  const variants = shopifyProduct.variants || [];
  const productOptions = [];
  let sortCounter = 1;

  variants.forEach(variant => {
    const parsed = parseWeightFromTitle(variant.title);
    if (!parsed) {
      console.log(
        `[${SETTINGS.experimentId}] Could not parse weight from variant "${variant.title}". Skipping.`
      );
      return;
    }

    const freqRule = findFrequencyRule(parsed.weightGrams);
    const badgeRule = findBadgeRule(parsed.weightGrams);

    productOptions.push({
      name:           parsed.sizeLabel,
      variantId:      String(variant.id),
      weightOz:       parsed.weightOz,
      weightLbs:      parsed.weightLbs,
      weightGrams:    parsed.weightGrams,
      qty:            1,
      pricePerUnit:   variant.price / 100,
      img:            variant.featured_image
                        ? variant.featured_image.src
                        : (shopifyProduct.featured_image || ""),
      frequencyKeys:  freqRule ? freqRule.frequencyKeys : [],
      sellingPlanIds: freqRule
      ? freqRule.frequencyKeys.map(key => SETTINGS.frequencies[key]?.sellingPlanId).filter(Boolean)
      : [],
      badge:          badgeRule ? badgeRule.badge : null,
      outOfStock:     !variant.available,
      sortOrder:      sortCounter,
    });

    sortCounter++;
  });

  productOptions.sort((a, b) => a.weightGrams - b.weightGrams);

  if (productOptions.length === 0) return null;

  return productOptions;
}


function findFrequencyRule(weightGrams) {
  return SETTINGS.frequencyRules.find(r =>
    weightGrams >= r.minGrams && weightGrams <= r.maxGrams
  ) || null;
}

function findBadgeRule(weightGrams) {
  return SETTINGS.badgeRules.find(r =>
    weightGrams >= r.minGrams && weightGrams <= r.maxGrams
  ) || null;
}


// =============================================================================
// HELPER — Price formatting
// =============================================================================

function fmt(price) {
  return `$${price.toFixed(2)}`;
}


// =============================================================================
// HELPER — URL variant parameter
// =============================================================================

function getVariantIdFromUrl() {
  const params = new URLSearchParams(window.location.search);
  return params.get("variant") || "";
}

function setVariantIdInUrl(variantId) {
  const url = new URL(window.location.href);
  url.searchParams.set("variant", variantId);
  window.history.replaceState({}, "", url.toString());
}


// =============================================================================
// MAIN
// =============================================================================

// =============================================================================
// ACTIVATION — Expose global function, do not auto-run
// =============================================================================

window.activatePC07 = async function activatePC07() {

  // Prevent double activation
  if (window._pc07Active) {
    console.log(`[${SETTINGS.experimentId}] Already activated. Skipping.`);
    return;
  }
  window._pc07Active = true;

  // --------------------------------------------------------------------------
  // Check if this product is in the allowed list (if list is defined)
  // --------------------------------------------------------------------------
  if (SETTINGS.productHandles && SETTINGS.productHandles.length > 0) {
    const pathParts = window.location.pathname.split("/").filter(Boolean);
    const productsIndex = pathParts.indexOf("products");
    const currentHandle = productsIndex !== -1 ? pathParts[productsIndex + 1] : "";

    if (!SETTINGS.productHandles.includes(currentHandle)) {
      console.log(
        `[${SETTINGS.experimentId}] Product "${currentHandle}" not in allowed list. Skipping.`
      );
      return;
    }
  }

  // --------------------------------------------------------------------------
  // Fetch product data from Shopify
  // --------------------------------------------------------------------------
  const shopifyProduct = await fetchShopifyProduct();
  if (!shopifyProduct) {
    if (SETTINGS.debug) console.log(`[${SETTINGS.experimentId}] Not a product page or fetch failed. Exiting.`);
    return;
  }

  // --------------------------------------------------------------------------
  // Auto-build product options from variants
  // --------------------------------------------------------------------------
  const productOptions = buildProductOptions(shopifyProduct);
  if (!productOptions || productOptions.length === 0) {
    console.log(`[${SETTINGS.experimentId}] No options could be built from variants. Exiting.`);
    return;
  }

  // --------------------------------------------------------------------------
  // Inject bundle options (multi-quantity of a base variant)
  // --------------------------------------------------------------------------
  if (SETTINGS.bundles && SETTINGS.bundles.length > 0) {
    SETTINGS.bundles.forEach(bundle => {
      const base = productOptions[bundle.baseVariantIndex];
      if (!base) return;

      const totalGrams = base.weightGrams * bundle.qty;
      const freqRule = findFrequencyRule(totalGrams);

      const fullBundlePrice = base.pricePerUnit * bundle.qty;
      const discount = bundle.discountPct || 0;
      const bundlePrice = fullBundlePrice * (1 - discount);

      const bundleOption = {
        name:           `${base.name} x ${bundle.qty}`,
        variantId:      base.variantId,
        weightOz:       base.weightOz,
        weightLbs:      base.weightLbs,
        weightGrams:    base.weightGrams,
        qty:            bundle.qty,
        pricePerUnit:   bundlePrice / bundle.qty,
        img:            base.img,
        frequencyKeys:  freqRule ? freqRule.frequencyKeys : base.frequencyKeys,
        sellingPlanIds: freqRule
          ? freqRule.frequencyKeys.map(key => SETTINGS.frequencies[key]?.sellingPlanId).filter(Boolean)
          : base.sellingPlanIds,
        badge:          bundle.badge || null,
        outOfStock:     base.outOfStock,
      };


      // Insert immediately after the base variant
      productOptions.splice(bundle.baseVariantIndex + 1, 0, bundleOption);
    });
  }

  // --------------------------------------------------------------------------
  // Calculate base per-cup price (most expensive = smallest size)
  // Used to show savings on OTP for larger/better-value sizes
  // --------------------------------------------------------------------------
  const basePerCup = Math.max(
    ...productOptions.map(opt => opt.pricePerUnit / calcCups(opt))
  );

  // --------------------------------------------------------------------------
  // Determine which variant is initially selected
  // --------------------------------------------------------------------------
  const discount = SETTINGS.subscribeDiscountPct;
  const urlVariantId = getVariantIdFromUrl();

  let selectedIndex = 0;
  for (let i = 0; i < productOptions.length; i++) {
    if (productOptions[i].variantId === urlVariantId) {
      selectedIndex = i;
      break;
    }
  }
  let selectedOption = productOptions[selectedIndex];

  window.sessionStorage.setItem(SETTINGS.experimentId, SETTINGS.version);


  // --------------------------------------------------------------------------
  // Build size cards HTML
  // --------------------------------------------------------------------------
  function buildSizeCardsHtml() {
    let html = "";
    productOptions.forEach((opt, idx) => {
      const cups = calcCups(opt);
      const isCurrent = idx === selectedIndex ? "current" : "";
      const isOOS = opt.outOfStock ? "out-of-stock" : "";
      const otpTotalForOption = opt.pricePerUnit * opt.qty;
      const subTotalForOption = otpTotalForOption * (1 - discount);
      const otpPerCup = cups > 0 ? fmt(otpTotalForOption / cups) : fmt(0);
      const subPerCup = cups > 0 ? fmt(subTotalForOption / cups) : fmt(0);

      // AFTER
      const stackCount = opt.qty > 1 ? Math.min(opt.qty, 3) : 0;
      const imgHtml = stackCount > 0
        ? Array.from({ length: stackCount }, (_, i) =>
            `<img src="${opt.img}" class="pc-product-image pc-stacked-image" alt="" />`
          ).join("\n              ")
        : `<img src="${opt.img}" width="200" height="200" class="pc-product-image" alt="${opt.name}" />`;

      let badgeHtml = opt.badge
        ? `<span class="pc-badge">${opt.badge}</span>`
        : "";

      html += `
        <li class="pc-size-item" data-option-index="${idx}">
          <button type="button"
                  class="pc-size-card ${isCurrent} ${isOOS}"
                  ${isOOS ? "disabled" : ""}
                  data-variant-id="${opt.variantId}"
                  data-option-index="${idx}"
                  data-otp-total="${otpTotalForOption.toFixed(2)}">
            ${badgeHtml}
            <div class="pc-card-media${opt.qty > 1 ? ' pc-card-media--multi' : ''}"${opt.qty > 1 ? ` role="img" aria-label="${opt.name}" style="--qty: ${opt.qty};"` : ''}>
              ${imgHtml}
            </div>
            <span class="pc-size-name">${opt.name}</span>
            <span class="pc-size-cups">${cups} cups</span>
            <span class="pc-price-otp">${otpPerCup} / cup</span>
            <span class="pc-price-sub">${subPerCup} / cup</span>
          </button>
        </li>
      `;
    });
    return html;
  }


  // --------------------------------------------------------------------------
  // Build frequency dropdown HTML
  // --------------------------------------------------------------------------
  function buildFrequencyHtml() {
    let html = "";
    selectedOption.frequencyKeys.forEach((key, i) => {
      const freq = SETTINGS.frequencies[key];
      if (!freq) return;
      const cupsLabel = calcCupsPerDayLabel(selectedOption, freq.weeks);
      html += `
        <option ${i === 0 ? "selected" : ""}
                value="${freq.sellingPlanId}:${selectedOption.qty}"
                data-weeks="${freq.weeks}">
          ${freq.label} (${cupsLabel})
        </option>
      `;
    });
    return html;
  }


  // --------------------------------------------------------------------------
  // Build the full UI
  // --------------------------------------------------------------------------
  function buildFullHtml() {
    const otpTotal = selectedOption.pricePerUnit * selectedOption.qty;
    const subTotal = otpTotal * (1 - discount);
    const subSavings = otpTotal - subTotal;
    const discountLabel = Math.round(discount * 100);

    const cups = calcCups(selectedOption);
    const baseTotal = basePerCup * cups;
    const otpSavings = baseTotal - otpTotal;
    const showOtpSavings = otpSavings > 0.01 && selectedOption.qty > 1;

    return `
      <div class="pc-purchase-options" data-mode="otp">

        <div class="pc-option-block pc-otp is-selected" data-mode="otp">
          <div class="pc-radio-row">
            <div class="pc-radio">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5" />
                <circle class="pc-radio-dot" cx="12" cy="12" r="6" fill="currentColor" />
              </svg>
            </div>
            <div class="pc-option-header">
              <h2 class="pc-option-title">One-Time Purchase</h2>
              <p class="pc-option-price">
                ${showOtpSavings
                  ? `<span id="pc-otp-compare" class="pc-compare-price">${fmt(baseTotal)}</span>`
                  : `<span id="pc-otp-compare" class="pc-compare-price" style="display:none;"></span>`}
                <span id="pc-otp-total" class="pc-total-price">${fmt(otpTotal)}</span>
              </p>
            </div>
          </div>
          <p class="pc-savings pc-otp-savings" ${showOtpSavings ? '' : 'style="display:none;"'}>
            You save <span id="pc-otp-savings">${showOtpSavings ? fmt(otpSavings) : ''}</span>!
          </p>
        </div>

        <div class="pc-option-block pc-sub" data-mode="sub">
          <div class="pc-radio-row">
            <div class="pc-radio">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5" />
                <circle class="pc-radio-dot" cx="12" cy="12" r="6" fill="currentColor" />
              </svg>
            </div>
            <div class="pc-option-header">
              <h2 class="pc-option-title">Subscribe &amp; Save ${discountLabel}%</h2>
              <p class="pc-option-price">
                <span id="pc-sub-compare" class="pc-compare-price">${fmt(otpTotal)}</span>
                <span id="pc-sub-total" class="pc-total-price pc-sale">${fmt(subTotal)}</span>
              </p>
            </div>
          </div>
          <p class="pc-savings">You save <span id="pc-sub-savings">${fmt(subSavings)}</span>!</p>

          <div class="pc-frequency-wrapper" style="display: none;">
            <label class="pc-freq-label" for="pc-frequency-select">Delivery Frequency</label>
            <select class="pc-frequency-select" id="pc-frequency-select">
              ${buildFrequencyHtml()}
            </select>
          </div>
        </div>

        <div class="pc-sizes-section">
          <h3 class="pc-sizes-heading">Choose Your Size</h3>
          <ul class="pc-sizes-list">
            ${buildSizeCardsHtml()}
          </ul>
        </div>

      </div>
    `;
  }

  const cssStyles = `
    <style id="pc-custom-styles">
      .product-block.product-block--price, .product-block[data-dynamic-variants-enabled], .product__quantity, .skio-group-content .btn-group { display: none; }

      .skio-plan-picker,
      .skio-plan-picker .product-option-heading,
      pdp-price,
      .product-buy-buttons .quantity-input-form {
        display: none !important;
      }

      .pc-purchase-options {
        max-width: 100%;
        margin-bottom: 20px;
      }

      .pc-option-block {
        border: 1.5px solid #ddd;
        border-radius: 6px;
        padding: 14px 16px;
        margin-bottom: 10px;
        cursor: pointer;
        transition: border-color 0.2s, background-color 0.2s;
        position: relative;
      }

      .pc-option-block.is-selected {
        border-color: ${SETTINGS.brandPrimary};
        border-width: 2px;
        background-color: ${SETTINGS.brandBackground};
      }

      .pc-option-block:not(.is-selected) .pc-radio-dot {
        display: none;
      }

      .pc-option-block:not(.is-selected) .pc-savings,
      .pc-option-block:not(.is-selected) .pc-frequency-wrapper {
        display: none !important;
      }

      .pc-radio-row {
        display: flex;
        align-items: center;
        gap: 10px;
      }

      .pc-radio {
        flex-shrink: 0;
        color: ${SETTINGS.brandPrimary};
      }

      .pc-option-header {
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
      }

      .pc-option-block .pc-option-title {
        font-family: var(--typeBasePrimary), var(--typeBaseFallback);
        font-size: 1rem;
        margin: 0;
      }

      .pc-option-price {
        margin: 0;
        font-weight: 800;
        font-size: 1.2rem;
      }

      .pc-compare-price {
        text-decoration: line-through;
        font-size: 14px;
        font-weight: 400;
        color: #999;
        margin-right: 6px;
      }

      .pc-sale {
        color: ${SETTINGS.brandAccent};
      }

      .pc-savings {
        font-size: 14px;
        text-align: right;
        margin: -4px 0;
        color: ${SETTINGS.brandAccent};
        font-weight: 600;
      }

      .pc-frequency-wrapper {
        margin-top: 10px;
      }

      .pc-freq-label {
        display: block;
        font-size: 12px;
        font-weight: 600;
        margin-bottom: 4px;
        color: ${SETTINGS.brandPrimary};
      }

      .pc-frequency-select {
        width: 100%;
        font-size: 14px;
        padding: 10px 32px 10px 12px;
        border: 1.5px solid ${SETTINGS.brandPrimary};
        border-radius: 4px;
        background: #fff;
        color: ${SETTINGS.brandPrimary};
        appearance: none;
        -webkit-appearance: none;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'%3E%3Cpath stroke-width='0' fill='%230f0f0f' d='M21.4,6.6l-9.4,6.6L2.6,6.6l-.6.9,8.5,8.9c.7.8,1.1,1,1.5,1s.8-.3,1.5-1l8.5-8.9-.6-.9Z'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: calc(100% - 10px) center;
        background-size: 16px;
        cursor: pointer;
      }

      .pc-sizes-section {
        margin-top: 18px;
      }

      .pc-sizes-section .pc-sizes-heading {
        font-size: 14px;
        font-weight: 700;
        margin: 0 0 10px 0;
      }

      .pc-sizes-list {
        list-style: none;
        padding: 0;
        margin: 0;
        display: flex;
        gap: 10px;
        transition: opacity 0.25s ease, transform 0.25s ease;
      }

      .pc-sizes-list.pc-transitioning-out {
        opacity: 0;
        transform: translateY(6px);
      }

      .pc-sizes-list.pc-transitioning-in {
        opacity: 0;
        transform: translateY(-6px);
      }

      .pc-size-item {
        flex: 1;
        min-width: 0;
      }

      .pc-size-card {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        padding: 10px 6px 8px 6px;
        border: 1.5px solid #ddd;
        border-radius: 6px;
        background: #fff;
        cursor: pointer;
        transition: border-color 0.2s, box-shadow 0.2s;
        position: relative;
        font-family: inherit;
        text-align: center;
      }

      .pc-size-card:hover {
        border-color: ${SETTINGS.brandAccent};
      }

      .pc-size-card.current {
        border-color: ${SETTINGS.brandPrimary};
        border-width: 2px;
        box-shadow: 0 0 0 1px ${SETTINGS.brandPrimary}22;
      }

      .pc-size-card.out-of-stock {
        opacity: 0.4;
        pointer-events: none;
      }

      .pc-size-card[disabled] {
        cursor: not-allowed;
      }

      .pc-badge {
        position: absolute;
        top: -9px;
        left: 50%;
        transform: translateX(-50%);
        background: ${SETTINGS.brandPrimary};
        color: #fff;
        font-size: 10px;
        font-weight: 800;
        padding: 2px 8px;
        border-radius: 3px;
        white-space: nowrap;
        line-height: 1.6;
        letter-spacing: 0.3px;
      }

      .pc-badge.pc-badge--outline {
        background: #fff;
        color: ${SETTINGS.brandPrimary};
        border: 1px solid ${SETTINGS.brandPrimary};
      }

      .pc-card-media {
        position: relative;
        width: 100%;
        height: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 4px;
        overflow: hidden;
      }

      .pc-product-image {
        width: 70px;
        height: 70px;
        object-fit: contain;
        position: relative;
      }

      .pc-size-name {
        font-size: 14px;
        font-weight: 700;
        color: ${SETTINGS.brandPrimary};
        line-height: 1.3;
      }

      .pc-size-cups {
        font-size: 12px;
        color: #777;
        margin-top: 1px;
      }

      .pc-price-otp,
      .pc-price-sub {
        font-size: 12px;
        color: #555;
        margin-top: 2px;
        transition: color 0.3s ease, font-weight 0.3s ease;
      }

      .pc-purchase-options[data-mode="otp"] .pc-price-sub,
      .pc-purchase-options[data-mode="sub"] .pc-price-otp {
        display: none;
      }
      
      .pc-stacked-image { position: relative; }
      .pc-stacked-image:first-child { left: calc(12px * (var(--qty) - 1)); }
      .pc-stacked-image:last-child  { left: calc(-12px * (var(--qty) - 1)); }

      @media screen and (max-width: 768px) {
        .pc-sizes-list {
          gap: 6px;
        }

        .pc-size-card {
          padding: 8px 4px 6px 4px;
        }

        .pc-card-media {
          height: 60px;
        }

        .pc-product-image {
          width: 55px;
          height: 55px;
        }

        .pc-size-name {
          font-size: 12px;
        }

        .pc-option-header {
          flex-direction: column;
          align-items: flex-start;
          gap: 2px;
        }
      }
    </style>
  `;


  // --------------------------------------------------------------------------
  // Inject UI & wire up interactivity
  // --------------------------------------------------------------------------
  waitForElement(".skio-plan-picker").then(skioContainer => {

    skioContainer.insertAdjacentHTML("beforebegin", cssStyles + buildFullHtml());

    const root        = document.querySelector(".pc-purchase-options");
    const otpBlock    = root.querySelector(".pc-otp");
    const subBlock    = root.querySelector(".pc-sub");
    const freqSelect  = root.querySelector(".pc-frequency-select");
    const freqWrapper = root.querySelector(".pc-frequency-wrapper");

    let currentMode = "otp";


    function animateSizeListTransition() {
      const sizeList = root.querySelector(".pc-sizes-list");
      const cards = root.querySelectorAll(".pc-size-card");

      sizeList.classList.add("pc-transitioning-out");

      setTimeout(() => {
        sizeList.classList.remove("pc-transitioning-out");
        sizeList.classList.add("pc-transitioning-in");
        void sizeList.offsetHeight;
        sizeList.classList.remove("pc-transitioning-in");

        cards.forEach(card => {
          card.classList.add("pc-price-updated");
          setTimeout(() => {
            card.classList.remove("pc-price-updated");
          }, 600);
        });
      }, 250);
    }


    function updatePrices() {
      const otpTotal = selectedOption.pricePerUnit * selectedOption.qty;
      const subTotal = otpTotal * (1 - discount);
      const subSavings = otpTotal - subTotal;

      const cups = calcCups(selectedOption);
      const baseTotal = basePerCup * cups;
      const otpSavings = baseTotal - otpTotal;
      const showOtpSavings = otpSavings > 0.01 && selectedOption.qty > 1;

      document.getElementById("pc-otp-total").textContent = fmt(otpTotal);

      const otpCompareEl = document.getElementById("pc-otp-compare");
      const otpSavingsEl = document.getElementById("pc-otp-savings");
      const otpSavingsRow = otpSavingsEl ? otpSavingsEl.parentElement : null;

      if (otpCompareEl) {
        otpCompareEl.textContent = showOtpSavings ? fmt(baseTotal) : "";
        otpCompareEl.style.display = showOtpSavings ? "" : "none";
      }

      if (otpSavingsRow) {
        otpSavingsEl.textContent = showOtpSavings ? fmt(otpSavings) : "";
        otpSavingsRow.style.display = showOtpSavings ? "" : "none";
      }

      document.getElementById("pc-sub-compare").textContent = fmt(otpTotal);
      document.getElementById("pc-sub-total").textContent = fmt(subTotal);
      document.getElementById("pc-sub-savings").textContent = fmt(subSavings);

      freqSelect.innerHTML = buildFrequencyHtml();
    }


    function setMode(mode) {
      if (mode === currentMode) return;

      currentMode = mode;
      root.setAttribute("data-mode", mode);

      if (mode === "otp") {
        otpBlock.classList.add("is-selected");
        subBlock.classList.remove("is-selected");
        freqWrapper.style.display = "none";
      } else {
        otpBlock.classList.remove("is-selected");
        subBlock.classList.add("is-selected");
        freqWrapper.style.display = "block";
      }

      animateSizeListTransition();
    }


    function selectSize(index) {
      selectedIndex  = index;
      selectedOption = productOptions[index];

      root.querySelectorAll(".pc-size-card").forEach((card, i) => {
        card.classList.toggle("current", i === index);
      });

      setVariantIdInUrl(selectedOption.variantId);
      updatePrices();

      // Update the native Shopify variant select
      selectShopifyVariant(selectedOption.variantId);
    }


    // ------------------------------------------------------------------
    // Core: Select variant in Shopify's native form
    // ------------------------------------------------------------------
    function selectShopifyVariant(variantId) {
      const productSection = document.querySelector('.product-single__form, form[action*="/cart/add"].product-single__form');
      const scope = productSection || document;
      scope.querySelectorAll('select[name="id"]').forEach(el => {
        for (let i = 0; i < el.options.length; i++) {
          if (el.options[i].value === variantId) {
            el.options[i].selected = true;
            el.dispatchEvent(new Event("change", { bubbles: true }));
            break;
          }
        }
      });
      scope.querySelectorAll('input[name="id"]').forEach(el => {
        el.value = variantId;
        el.dispatchEvent(new Event("change", { bubbles: true }));
      });
    }


    // ------------------------------------------------------------------
    // Core: Intercept ALL cart/add requests
    // This runs immediately — does NOT depend on Skio loading
    // ------------------------------------------------------------------
    const originalFetch = window.fetch;
    window.fetch = function(url, options) {
      if (typeof url === "string" && url.indexOf("/cart/add") > -1 && options && options.body && window._pc07Submitting) {
        try {
          const body = options.body;

          if (typeof body === "string" && body.indexOf("form_type=product") > -1) {
            // URL-encoded form body
            const params = new URLSearchParams(body);

            params.set("id", selectedOption.variantId);
            params.set("quantity", String(selectedOption.qty));

            if (currentMode === "sub") {
              const freqVal = freqSelect.value;
              if (freqVal) {
                params.set("selling_plan", freqVal.split(":")[0]);
              }
            } else {
              params.set("selling_plan", "");
            }

            options.body = params.toString();
          } else if (typeof body === "string") {
            try {
              let json = JSON.parse(body);

              if (json.id != null) {
                json.id = parseInt(selectedOption.variantId);
                json.quantity = selectedOption.qty;
              }
              if (json.items && json.items.length > 0) {
                json.items[0].id = parseInt(selectedOption.variantId);
                json.items[0].quantity = selectedOption.qty;
              }

              if (currentMode === "sub") {
                const freqVal = freqSelect.value;
                if (freqVal) {
                  const planId = parseInt(freqVal.split(":")[0]);
                  if (json.selling_plan != null) json.selling_plan = planId;
                  if (json.items && json.items.length > 0) json.items[0].selling_plan = planId;
                }
              }

              options.body = JSON.stringify(json);
            } catch (e) { /* not JSON */ }

          } else if (body instanceof FormData) {
            body.set("id", selectedOption.variantId);
            body.set("quantity", String(selectedOption.qty));

            if (currentMode === "sub") {
              const freqVal = freqSelect.value;
              if (freqVal) {
                body.set("selling_plan", freqVal.split(":")[0]);
              }
            } else {
              body.set("selling_plan", "");
            }
          }
        } catch (e) {
          console.error(`[${SETTINGS.experimentId}] Error intercepting cart`, e);
        }
      }
      return originalFetch.call(this, url, options);
    };

    // ------------------------------------------------------------------
    // Core: Also intercept form submissions directly
    // ------------------------------------------------------------------
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      form.addEventListener("submit", () => {
        window._pc07Submitting = true;
        // Force variant
        const idSelect = form.querySelector('select[name="id"]');
        if (idSelect) {
          for (let i = 0; i < idSelect.options.length; i++) {
            if (idSelect.options[i].value === selectedOption.variantId) {
              idSelect.options[i].selected = true;
              break;
            }
          }
        }

        // Force or create selling_plan input
        let spInput = form.querySelector('input[name="selling_plan"]');
        if (!spInput) {
          spInput = document.createElement("input");
          spInput.type = "hidden";
          spInput.name = "selling_plan";
          form.appendChild(spInput);
        }

        if (currentMode === "sub") {
          const freqVal = freqSelect.value;
          spInput.value = freqVal ? freqVal.split(":")[0] : "";
        } else {
          spInput.value = "";
        }

        // Force or create quantity input
        let qtyInput = form.querySelector('input[name="quantity"]');
        if (!qtyInput) {
          qtyInput = document.createElement("input");
          qtyInput.type = "hidden";
          qtyInput.name = "quantity";
          form.appendChild(qtyInput);
        }
        qtyInput.value = String(selectedOption.qty);
        setTimeout(() => { window._pc07Submitting = false; }, 500);
      }, true); // useCapture = true to run BEFORE other handlers
    });

    // ------------------------------------------------------------------
    // Click handlers
    // ------------------------------------------------------------------
    otpBlock.addEventListener("click", () => {
      setMode("otp");
      selectShopifyVariant(selectedOption.variantId);
    });

    subBlock.addEventListener("click", () => {
      setMode("sub");
      selectShopifyVariant(selectedOption.variantId);
    });

    root.querySelectorAll(".pc-size-card").forEach(card => {
      card.addEventListener("click", (e) => {
        e.stopPropagation();
        const idx = parseInt(card.getAttribute("data-option-index"), 10);
        selectSize(idx);
      });
    });


    // ------------------------------------------------------------------
    // Set initial state
    // ------------------------------------------------------------------
    selectShopifyVariant(selectedOption.variantId);


    // ------------------------------------------------------------------
    // Optional: Wire into Skio Shadow DOM (enhances but not required)
    // ------------------------------------------------------------------
    waitForElement("skio-plan-picker").then(planPicker => {
      waitUntil(() => !!(
        planPicker.shadowRoot &&
        planPicker.shadowRoot.querySelector("select.selling-plan-dropdown") &&
        planPicker.shadowRoot.querySelector("select.selling-plan-dropdown").options.length > 0
      )).then(() => {

        const skioSubsRadio    = planPicker.shadowRoot.querySelector('[id*="group-0-skio_plan_picker_"]');
        const skioOtpRadio     = planPicker.shadowRoot.querySelector('[id*="one-time-skio_plan_"]');
        const skioDropdown     = planPicker.shadowRoot.querySelector("select.selling-plan-dropdown");
        const skioDropdownOpts = skioDropdown.options;

        function syncSkioPlan(sellingPlanId) {
          for (let i = 0; i < skioDropdownOpts.length; i++) {
            if (skioDropdownOpts[i].value === sellingPlanId) {
              skioDropdownOpts[i].selected = true;
              skioDropdown.dispatchEvent(new Event("change", { bubbles: true }));
              break;
            }
          }
        }

        function activateSkioOtp() {
          if (skioOtpRadio) {
            skioOtpRadio.checked = true;
            skioOtpRadio.dispatchEvent(new Event("change", { bubbles: true }));
          }
        }

        function activateSkioSubs() {
          if (skioSubsRadio) {
            skioSubsRadio.checked = true;
            skioSubsRadio.dispatchEvent(new Event("change", { bubbles: true }));
          }
        }

        function hideIrrelevantSkioPlans() {
          const validIds = selectedOption.sellingPlanIds || [];
          for (let i = 0; i < skioDropdownOpts.length; i++) {
            skioDropdownOpts[i].hidden = !validIds.includes(skioDropdownOpts[i].value);
          }
        }

        window.applyToSkio = function applyToSkio() {
          selectShopifyVariant(selectedOption.variantId);

          if (currentMode === "otp") {
            activateSkioOtp();
          } else {
            activateSkioSubs();
            const freqVal = freqSelect.value;
            if (freqVal) {
              syncSkioPlan(freqVal.split(":")[0]);
            }
          }

          hideIrrelevantSkioPlans();
        };

        // Re-bind with Skio integration
        otpBlock.addEventListener("click", () => window.applyToSkio());
        subBlock.addEventListener("click", () => window.applyToSkio());

        freqSelect.addEventListener("change", () => {
          const val = freqSelect.value;
          if (!val) return;
          syncSkioPlan(val.split(":")[0]);
        });

        // Initial Skio state
        hideIrrelevantSkioPlans();
        window.applyToSkio();
      });
    });
  });
  
};

console.log(`[${SETTINGS.experimentId}] Ready.`);


// =============================================================================
// PUR-09 — Pods & Sachets Custom Purchase UI
// =============================================================================

window.activatePC09 = async function activatePC09() {

  if (window._pc09Active) {
    console.log("[PC-09] Already activated. Skipping.");
    return;
  }
  window._pc09Active = true;

  // ---------------------------------------------------------------------------
  // SETTINGS
  // ---------------------------------------------------------------------------

  const SETTINGS = {
    experimentId: "PC-09",

    podHandles: [
      "original-roast-coffee-pods",
      "dark-roast-roast-coffee-pods",
      "decaf-coffee-pods",
      "purity-protect-coffee-pods",
      "balance-caff-single-serve-purity-pods%E2%84%A2"
    ],

    sachetHandles: [
      "original-roast-coffee-sachets",
      "decaf-coffee-sachets",
      "dark-roast-coffee-sachets",
      "protect-pocket-purity",
      "balance-caff-single-serve-pocket-purity%E2%84%A2"
    ],
    groundHandles: [
      "flow-original-medium-roast-ground-coffee",
      "ease-dark-roast-ground-coffee",
      "calm-decaf-ground-coffee",
      "protect-light-medium-roast-ground-coffee",
      "balance-caff-ground-coffee"
    ],

    // grams per unit (used for cups calculation and frequency rules)
    podGrams:    144,
    sachetGrams: 65,

    // grams per cup (same as PC07)
    gramsPerCup: 13.34,

    // unit conversions
    ouncesToGrams: 28.3495,
    poundsToGrams: 453.592,

    // subscribe discount
    subscribeDiscountPct: 0.10,

    // bundles: defined per product type
    podBundles: [
      { qty: 2, discountPct: 1 - (40/44) },  // $41 vs $44
      { qty: 4, discountPct: 1 - (76/88) },    // $81 vs $88
    ],
    sachetBundles: [
      { qty: 3, discountPct: 1 - (36/39) },  // $36 vs $39
    ],
    groundBundles: [
      { baseVariantIndex: 0, qty: 3, discountPct: 0.069, badge: null },
    ],

    frequencies: {
      "4w":  { weeks: 4,  label: "Every 4 Weeks",  sellingPlanId: "1493631145" },
      "6w":  { weeks: 6,  label: "Every 6 Weeks",  sellingPlanId: "1493663913" },
      "8w":  { weeks: 8,  label: "Every 8 Weeks",  sellingPlanId: "1493696681" },
      "10w": { weeks: 10, label: "Every 10 Weeks", sellingPlanId: "1493729449" },
      "12w": { weeks: 12, label: "Every 12 Weeks", sellingPlanId: "1493762217" },
    },

    groundFrequencies: {
      "4w":  { weeks: 4,  label: "Every 4 Weeks",  sellingPlanId: "1493467305" },
      "6w":  { weeks: 6,  label: "Every 6 Weeks",  sellingPlanId: "1493500073" },
      "8w":  { weeks: 8,  label: "Every 8 Weeks",  sellingPlanId: "1493532841" },
      "10w": { weeks: 10, label: "Every 10 Weeks", sellingPlanId: "1493565609" },
      "12w": { weeks: 12, label: "Every 12 Weeks", sellingPlanId: "1493598377" },
    },

    frequencyRules: [
      { minGrams: 0,    maxGrams: 400,     frequencyKeys: ["4w","6w","8w"] },
      { minGrams: 401,  maxGrams: 1200,    frequencyKeys: ["4w","6w","8w"] },
      { minGrams: 1201, maxGrams: Infinity, frequencyKeys: ["4w","8w","12w"] },
    ],

    badgeRules: [
      { minGrams: 2000, maxGrams: Infinity, badge: "Best Value" },
    ],
  };

  // ---------------------------------------------------------------------------
  // Detect product type from handle
  // ---------------------------------------------------------------------------

  const pathParts = window.location.pathname.split("/").filter(Boolean);
  const pi = pathParts.indexOf("products");
  if (pi === -1 || pi >= pathParts.length - 1) return;
  const currentHandle = pathParts[pi + 1];

  const isPod    = SETTINGS.podHandles.includes(currentHandle);
  const isSachet = SETTINGS.sachetHandles.includes(currentHandle);
  const isGround = SETTINGS.groundHandles.includes(currentHandle);

  if (!isPod && !isSachet && !isGround) {
    console.log(`[PC-09] Handle "${currentHandle}" not in pod or sachet list. Skipping.`);
    return;
  }

  const unitGrams = isGround ? 0 : (isPod ? SETTINGS.podGrams : SETTINGS.sachetGrams);
  const baseLabel = isGround ? "" : (isPod ? "12 pods" : "5ct");
  const bundles   = isGround ? [] : (isPod ? SETTINGS.podBundles : SETTINGS.sachetBundles); 
  const discount    = SETTINGS.subscribeDiscountPct;

  // ---------------------------------------------------------------------------
  // Fetch product
  // ---------------------------------------------------------------------------

  let shopifyProduct;
  try {
    const res = await fetch(`/products/${currentHandle}.js`);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    shopifyProduct = await res.json();
  } catch (err) {
    console.error("[PC-09] Failed to fetch product:", err);
    return;
  }

  // ---------------------------------------------------------------------------
  // Helpers
  // ---------------------------------------------------------------------------

  function findFreqRule(g) {
    return SETTINGS.frequencyRules.find(r => g >= r.minGrams && g <= r.maxGrams) || null;
  }

  function calcUnits(opt) {
    return opt.unitsPerCarton * opt.qty;
  }

  function fmt(p) { return `$${p.toFixed(2)}`; }

  // ---------------------------------------------------------------------------
  // Build options from variants
  // ---------------------------------------------------------------------------

  const opts = [];

  if (isGround) {
    // --- PC07-style: parse weight from oz/lb variant titles ---
    shopifyProduct.variants.forEach(v => {
      const parsed = parseWeightFromTitle(v.title);
      if (!parsed) {
        console.log(`[PC-09] Could not parse weight from variant "${v.title}". Skipping.`);
        return;
      }
      const fr = findFreqRule(parsed.weightGrams);
      const badgeRule = SETTINGS.badgeRules
        ? SETTINGS.badgeRules.find(r => parsed.weightGrams >= r.minGrams && parsed.weightGrams <= r.maxGrams) || null
        : null;

      opts.push({
        name:           parsed.sizeLabel,
        variantId:      String(v.id),
        weightGrams:    parsed.weightGrams,
        weightOz:       parsed.weightOz,
        weightLbs:      parsed.weightLbs,
        qty:            1,
        pricePerUnit:   v.price / 100,
        img:            v.featured_image ? v.featured_image.src : (shopifyProduct.featured_image || ""),
        frequencyKeys:  fr ? fr.frequencyKeys : [],
        sellingPlanIds: fr ? fr.frequencyKeys.map(k => SETTINGS.groundFrequencies[k]?.sellingPlanId).filter(Boolean) : [],
        badge:          badgeRule ? badgeRule.badge : null,
        outOfStock:     !v.available,
      });
    });

    opts.sort((a, b) => a.weightGrams - b.weightGrams);

    // Inject ground bundles
    if (SETTINGS.groundBundles) {
      SETTINGS.groundBundles.forEach(bundle => {
        const base = opts[bundle.baseVariantIndex];
        if (!base) return;
        const totalGrams   = base.weightGrams * bundle.qty;
        const fr2          = findFreqRule(totalGrams);
        const fullPrice    = base.pricePerUnit * bundle.qty;
        const bundlePrice  = fullPrice * (1 - (bundle.discountPct || 0));
        opts.splice(bundle.baseVariantIndex + 1, 0, {
          name:           `${base.name} x ${bundle.qty}`,
          variantId:      base.variantId,
          weightGrams:    base.weightGrams,
          weightOz:       base.weightOz,
          weightLbs:      base.weightLbs,
          qty:            bundle.qty,
          pricePerUnit:   bundlePrice / bundle.qty,
          img:            base.img,
          frequencyKeys:  fr2 ? fr2.frequencyKeys : base.frequencyKeys,
          sellingPlanIds: fr2 ? fr2.frequencyKeys.map(k => SETTINGS.groundFrequencies[k]?.sellingPlanId).filter(Boolean) : base.sellingPlanIds,
          badge:          bundle.badge || null,
          outOfStock:     base.outOfStock,
        });
      });
    }

  } else {
    // --- PC09-style: fixed grams per carton ---
    shopifyProduct.variants.forEach(v => {
      const isDefault = !v.title || v.title === "Default Title";
      const wg = isDefault ? unitGrams : (() => {
        const m = v.title.match(/(\d+(?:\.\d+)?)\s*(oz|lb|lbs|ounce|ounces|pound|pounds)/i);
        if (!m) return unitGrams;
        const val = parseFloat(m[1]), unit = m[2].toLowerCase();
        if (unit === 'oz' || unit === 'ounce' || unit === 'ounces') return val * SETTINGS.ouncesToGrams;
        if (unit === 'lb' || unit === 'lbs' || unit === 'pound' || unit === 'pounds') return val * SETTINGS.poundsToGrams;
        return unitGrams;
      })();
      const fr = findFreqRule(wg);
      opts.push({
        name:           "1 carton",
        variantId:      String(v.id),
        weightGrams:    wg,
        qty:            1,
        unitsPerCarton: isPod ? 12 : 5,
        unitLabel:      isPod ? "pods" : "sachets",
        pricePerUnit:   v.price / 100,
        img:            shopifyProduct.images[1] || shopifyProduct.images[0] || "",
        frequencyKeys:  fr ? fr.frequencyKeys : [],
        sellingPlanIds: fr ? fr.frequencyKeys.map(k => SETTINGS.frequencies[k]?.sellingPlanId).filter(Boolean) : [],
        outOfStock:     !v.available,
      });
    });

    opts.sort((a, b) => a.weightGrams - b.weightGrams);

    [...bundles].reverse().forEach(bundle => {
      const base        = opts[0];
      const fullPrice   = base.pricePerUnit * bundle.qty;
      const bundlePrice = fullPrice * (1 - bundle.discountPct);
      const totalGrams  = base.weightGrams * bundle.qty;
      const fr2         = findFreqRule(totalGrams);
      opts.splice(1, 0, {
        name:           `${bundle.qty} cartons`,
        variantId:      base.variantId,
        weightGrams:    base.weightGrams,
        qty:            bundle.qty,
        unitsPerCarton: base.unitsPerCarton,
        unitLabel:      base.unitLabel,
        pricePerUnit:   bundlePrice / bundle.qty,
        subPrice:       bundle.subPrice || null,
        img:            base.img,
        frequencyKeys:  fr2 ? fr2.frequencyKeys : base.frequencyKeys,
        sellingPlanIds: fr2 ? fr2.frequencyKeys.map(k => SETTINGS.frequencies[k]?.sellingPlanId).filter(Boolean) : base.sellingPlanIds,
        outOfStock:     base.outOfStock,
      });
    });
  }

  const baseUnitPrice = opts[0].pricePerUnit;

  // ---------------------------------------------------------------------------
  // State — set AFTER bundle splice so index 0 is always the base card
  // ---------------------------------------------------------------------------

  let selIdx = 0;
  let selOpt = opts[0];  // always the base variant, never a bundle
  let currentMode = "sub";

  // ---------------------------------------------------------------------------
  // Fetch intercept (runs immediately)
  // ---------------------------------------------------------------------------

  if (!window._pc09FetchPatched) {
    window._pc09FetchPatched = true;
    const _origFetch = window.fetch;
    window.fetch = function(url, options) {
      if (
        typeof url === "string" &&
        url.indexOf("/cart/add") > -1 &&
        options && options.body &&
        window._pc09Submitting
      ) {
        const s = window._pc09State;
        try {
          const body = options.body;
          if (typeof body === "string" && body.indexOf("form_type=product") > -1) {
            const p = new URLSearchParams(body);
            p.set("id", s.variantId);
            p.set("quantity", String(s.qty));
            p.set("selling_plan", s.mode === "sub" ? s.sellingPlanId : "");
            options.body = p.toString();
          } else if (typeof body === "string") {
            try {
              const j = JSON.parse(body);
              if (j.id != null) { j.id = parseInt(s.variantId); j.quantity = s.qty; }
              if (j.items?.[0]) { j.items[0].id = parseInt(s.variantId); j.items[0].quantity = s.qty; }
              if (s.mode === "sub" && s.sellingPlanId) {
                if (j.selling_plan != null) j.selling_plan = parseInt(s.sellingPlanId);
                if (j.items?.[0]) j.items[0].selling_plan = parseInt(s.sellingPlanId);
              }
              options.body = JSON.stringify(j);
            } catch(e) {}
          } else if (body instanceof FormData) {
            body.set("id", s.variantId);
            body.set("quantity", String(s.qty));
            body.set("selling_plan", s.mode === "sub" ? s.sellingPlanId : "");
          }
        } catch(e) { console.error("[PC-09] fetch intercept error", e); }
      }
      return _origFetch.apply(this, arguments);
    };
  }

  // ---------------------------------------------------------------------------
  // HTML builders
  // ---------------------------------------------------------------------------

  function sizeCardsHtml() {
    return opts.map((opt, idx) => {
      const units = calcUnits(opt);
      const otpTotal = opt.pricePerUnit * opt.qty;
      const subTotal = opt.subPrice != null ? opt.subPrice : otpTotal * (1 - discount);
      const imgHtml = opt.qty === 4
        ? Array.from({length: 4}, () =>
            `<img src="${opt.img}" class="pc-product-image pc-grid-image" alt="">`
          ).join("")
        : opt.qty > 1
          ? Array.from({length: Math.min(opt.qty, 3)}, () =>
              `<img src="${opt.img}" class="pc-product-image pc-stacked-image" alt="">`
            ).join("")
          : `<img src="${opt.img}" width="200" height="200" class="pc-product-image" alt="${opt.name}">`;
      const mediaAttr = opt.qty === 4
        ? ` role="img" aria-label="${opt.name}"`
        : opt.qty > 1 ? ` role="img" aria-label="${opt.name}" style="--qty:${opt.qty};"` : "";
      return `
        <li class="pc-size-item" data-option-index="${idx}">
          <button type="button"
                  class="pc-size-card${idx === selIdx ? " current" : ""}${opt.outOfStock ? " out-of-stock" : ""}"
                  ${opt.outOfStock ? "disabled" : ""}
                  data-variant-id="${opt.variantId}"
                  data-option-index="${idx}"
                  data-otp-total="${otpTotal.toFixed(2)}">
            <div class="pc-card-media${opt.qty === 4 ? " pc-card-media--grid" : opt.qty > 1 ? " pc-card-media--multi" : ""}"${mediaAttr}>
              ${imgHtml}
            </div>
            <span class="pc-size-name">${opt.name}</span>
            <span class="pc-size-cups">${isGround ? calcCups(opt) + " cups" : units + " " + opt.unitLabel}</span>
            <span class="pc-price-otp">${isGround ? fmt(otpTotal / calcCups(opt)) + " / cup" : fmt(otpTotal / calcUnits(opt)) + " / " + (isPod ? "pod" : "sachet")}</span>
            <span class="pc-price-sub">${isGround ? fmt(subTotal / calcCups(opt)) + " / cup" : fmt(subTotal / calcUnits(opt)) + " / " + (isPod ? "pod" : "sachet")}</span>

          </button>
        </li>`;
    }).join("");
  }

  function freqHtml(opt) {
    return opt.frequencyKeys.map((key, i) => {
      const freqMap = isGround ? SETTINGS.groundFrequencies : SETTINGS.frequencies;
      const f = freqMap[key];
      if (!f) return "";
      const cupsLabel = isGround ? ` (${calcCupsPerDayLabel(opt, f.weeks)})` : "";
      return `<option ${i === 0 ? "selected" : ""} value="${f.sellingPlanId}:${opt.qty}" data-weeks="${f.weeks}">
        ${f.label}${cupsLabel}
      </option>`;
    }).join("");
  }

  function fullHtml() {
    const otpTotal = selOpt.pricePerUnit * selOpt.qty;
    const subTotal = selOpt.subPrice != null ? selOpt.subPrice : otpTotal * (1 - discount);
    const subSavings = otpTotal - subTotal;
    const baseTotal = baseUnitPrice * selOpt.qty;
    const otpSavings = baseTotal - otpTotal;
    const showOtp = otpSavings > 0.01;
    const discPct = Math.round(discount * 100);

    return `
      <div class="pc-purchase-options" data-mode="${currentMode}">

        <div class="pc-option-block pc-otp${currentMode === "otp" ? " is-selected" : ""}" data-mode="otp">
          <div class="pc-radio-row">
            <div class="pc-radio">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/>
                <circle class="pc-radio-dot" cx="12" cy="12" r="6" fill="currentColor"/>
              </svg>
            </div>
            <div class="pc-option-header">
              <h2 class="pc-option-title">One-Time Purchase</h2>
              <p class="pc-option-price">
                <span id="pc-otp-compare" class="pc-compare-price"${showOtp ? "" : ' style="display:none;"'}>${showOtp ? fmt(baseTotal) : ""}</span>
                <span id="pc-otp-total" class="pc-total-price">${fmt(otpTotal)}</span>
              </p>
            </div>
          </div>
          <p class="pc-savings pc-otp-savings"${showOtp ? "" : ' style="display:none;"'}>
            You save <span id="pc-otp-savings">${showOtp ? fmt(otpSavings) : ""}</span>!
          </p>
        </div>

        <div class="pc-option-block pc-sub${currentMode === "sub" ? " is-selected" : ""}" data-mode="sub">
          <div class="pc-radio-row">
            <div class="pc-radio">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/>
                <circle class="pc-radio-dot" cx="12" cy="12" r="6" fill="currentColor"/>
              </svg>
            </div>
            <div class="pc-option-header">
              <h2 class="pc-option-title">Subscribe &amp; Save ${discPct}%</h2>
              <p class="pc-option-price">
                <span id="pc-sub-compare" class="pc-compare-price">${fmt(otpTotal)}</span>
                <span id="pc-sub-total" class="pc-total-price pc-sale">${fmt(subTotal)}</span>
              </p>
            </div>
          </div>
          <p class="pc-savings">You save <span id="pc-sub-savings">${fmt(subSavings)}</span>!</p>
          <div class="pc-frequency-wrapper" style="${currentMode === "sub" ? "" : "display:none;"}">
            <label class="pc-freq-label" for="pc-frequency-select">Delivery Frequency</label>
            <select class="pc-frequency-select" id="pc-frequency-select">
              ${freqHtml(selOpt)}
            </select>
          </div>
        </div>

        <div class="pc-sizes-section">
          <h3 class="pc-sizes-heading">Choose Your Size</h3>
          <ul class="pc-sizes-list">
            ${sizeCardsHtml()}
          </ul>
        </div>

      </div>`;
  }

  // ---------------------------------------------------------------------------
  // CSS (injected once — safe to run even if PC07 already injected these)
  // ---------------------------------------------------------------------------

  const style = document.createElement("style");
    style.id = "pc-custom-styles";
    style.textContent = `
      .product-block.product-block--price,
      .product-block[data-dynamic-variants-enabled],
      .product__quantity,
      .skio-group-content .btn-group { display: none; }

      .skio-plan-picker,
      .skio-plan-picker .product-option-heading,
      pdp-price,
      .product-buy-buttons .quantity-input-form { display: none !important; }

      .pc-purchase-options { max-width: 100%; margin-bottom: 20px; }

      .pc-option-block {
        border: 1.5px solid #ddd;
        border-radius: 6px;
        padding: 14px 16px;
        margin-bottom: 10px;
        cursor: pointer;
        transition: border-color 0.2s, background-color 0.2s;
        position: relative;
      }
      .pc-option-block.is-selected {
        border-color: #0f0f0f;
        border-width: 2px;
        background-color: #f8f8f8;
      }
      .pc-option-block:not(.is-selected) .pc-radio-dot { display: none; }
      .pc-option-block:not(.is-selected) .pc-savings,
      .pc-option-block:not(.is-selected) .pc-frequency-wrapper { display: none !important; }

      .pc-radio-row { display: flex; align-items: center; gap: 10px; }
      .pc-radio { flex-shrink: 0; color: #0f0f0f; }

      .pc-option-header {
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
      }
      .pc-option-block .pc-option-title {
        font-family: var(--typeBasePrimary), var(--typeBaseFallback);
        font-size: 1rem;
        margin: 0;
      }
      .pc-option-price { margin: 0; font-weight: 800; font-size: 1.2rem; }
      .pc-compare-price {
        text-decoration: line-through;
        font-size: 14px;
        font-weight: 400;
        color: #999;
        margin-right: 6px;
      }
      .pc-sale { color: #008075; }
      .pc-savings {
        font-size: 14px;
        text-align: right;
        margin: -4px 0;
        color: #008075;
        font-weight: 600;
      }

      .pc-frequency-wrapper { margin-top: 10px; }
      .pc-freq-label {
        display: block;
        font-size: 12px;
        font-weight: 600;
        margin-bottom: 4px;
        color: #0f0f0f;
      }
      .pc-frequency-select {
        width: 100%;
        font-size: 14px;
        padding: 10px 32px 10px 12px;
        border: 1.5px solid #0f0f0f;
        border-radius: 4px;
        background: #fff;
        color: #0f0f0f;
        appearance: none;
        -webkit-appearance: none;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'%3E%3Cpath stroke-width='0' fill='%230f0f0f' d='M21.4,6.6l-9.4,6.6L2.6,6.6l-.6.9,8.5,8.9c.7.8,1.1,1,1.5,1s.8-.3,1.5-1l8.5-8.9-.6-.9Z'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: calc(100% - 10px) center;
        background-size: 16px;
        cursor: pointer;
      }

      .pc-sizes-section { margin-top: 18px; }
      .pc-sizes-section .pc-sizes-heading { font-size: 14px; font-weight: 700; margin: 0 0 10px 0; }

      .pc-sizes-list {
        list-style: none;
        padding: 0;
        margin: 0;
        display: flex;
        gap: 10px;
        transition: opacity 0.25s ease, transform 0.25s ease;
      }
      .pc-sizes-list.pc-transitioning-out { opacity: 0; transform: translateY(6px); }
      .pc-sizes-list.pc-transitioning-in  { opacity: 0; transform: translateY(-6px); }

      .pc-size-item { flex: 1; min-width: 0; }
      .pc-size-card {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        padding: 10px 6px 8px 6px;
        border: 1.5px solid #ddd;
        border-radius: 6px;
        background: #fff;
        cursor: pointer;
        transition: border-color 0.2s, box-shadow 0.2s;
        position: relative;
        font-family: inherit;
        text-align: center;
      }
      .pc-size-card:hover { border-color: #008075; }
      .pc-size-card.current {
        border-color: #0f0f0f;
        border-width: 2px;
        box-shadow: 0 0 0 1px #0f0f0f22;
      }
      .pc-size-card.out-of-stock { opacity: 0.4; pointer-events: none; }
      .pc-size-card[disabled] { cursor: not-allowed; }

      .pc-badge {
        position: absolute;
        top: -9px;
        left: 50%;
        transform: translateX(-50%);
        background: #0f0f0f;
        color: #fff;
        font-size: 10px;
        font-weight: 800;
        padding: 2px 8px;
        border-radius: 3px;
        white-space: nowrap;
        line-height: 1.6;
        letter-spacing: 0.3px;
      }

      .pc-card-media {
        position: relative;
        width: 100%;
        height: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 4px;
        overflow: hidden;
        gap: 2px;
      }
      .pc-product-image { width: 70px; height: 70px; object-fit: contain; position: relative; }

      .pc-size-name { font-size: 14px; font-weight: 700; color: #0f0f0f; line-height: 1.3; }
      .pc-size-cups { font-size: 12px; color: #777; margin-top: 1px; }
      .pc-price-otp,
      .pc-price-sub { font-size: 12px; color: #555; margin-top: 2px; transition: color 0.3s ease; }

      .pc-purchase-options[data-mode="otp"] .pc-price-sub,
      .pc-purchase-options[data-mode="sub"] .pc-price-otp { display: none; }

      .pc-stacked-image { position: relative; }
      .pc-stacked-image:first-child { left: calc(6px * (var(--qty) - 1)); }
      .pc-stacked-image:last-child  { left: calc(-6px * (var(--qty) - 1)); }

      .pc-card-media--grid {
        position: relative;
        width: 80px;
        height: 80px;
        margin: 0 auto 4px;
        flex-shrink: 0;
      }
      .pc-card-media--grid .pc-grid-image {
        position: absolute;
        width: 42px;
        height: 42px;
        object-fit: contain;
      }
      .pc-card-media--grid .pc-grid-image:nth-child(1) { top: 0;   left: 0; }
      .pc-card-media--grid .pc-grid-image:nth-child(2) { top: 0;   right: 0; }
      .pc-card-media--grid .pc-grid-image:nth-child(3) { bottom: 0; left: 0; }
      .pc-card-media--grid .pc-grid-image:nth-child(4) { bottom: 0; right: 0; }

      @media screen and (max-width: 768px) {
        .pc-card-media--grid { width: 70px; height: 70px; }
        .pc-card-media--grid .pc-grid-image { width: 38px; height: 38px; }
        .pc-sizes-list { gap: 6px; }
        .pc-size-card { padding: 8px 4px 6px 4px; }
        .pc-card-media { height: 60px; }
        .pc-product-image { width: 48px; height: 48px; }
        .pc-size-name { font-size: 12px; }
        .pc-option-header { flex-direction: column; align-items: flex-start; gap: 2px; }
      }
    `;
    document.head.appendChild(style);

  // ---------------------------------------------------------------------------
  // Inject UI
  // ---------------------------------------------------------------------------

  waitForElement(".skio-plan-picker").then(skioContainer => {
    skioContainer.insertAdjacentHTML("beforebegin", fullHtml());

    const root       = document.querySelector(".pc-purchase-options");
    const otpBlock   = root.querySelector(".pc-otp");
    const subBlock   = root.querySelector(".pc-sub");
    const freqSelect = root.querySelector(".pc-frequency-select");
    const freqWrap   = root.querySelector(".pc-frequency-wrapper");

    function syncState() {
      const fv = freqSelect ? freqSelect.value : "";
      window._pc09State = {
        variantId:     selOpt.variantId,
        qty:           selOpt.qty,
        mode:          currentMode,
        sellingPlanId: currentMode === "sub" && fv ? fv.split(":")[0] : ""
      };
    }

    function animateList() {
      const list = root.querySelector(".pc-sizes-list");
      list.classList.add("pc-transitioning-out");
      setTimeout(() => {
        list.classList.remove("pc-transitioning-out");
        list.classList.add("pc-transitioning-in");
        void list.offsetHeight;
        list.classList.remove("pc-transitioning-in");
      }, 250);
    }

    function updatePrices() {
      const otpTotal   = selOpt.pricePerUnit * selOpt.qty;
      const subTotal   = selOpt.subPrice != null ? selOpt.subPrice : otpTotal * (1 - discount);
      const subSavings = otpTotal - subTotal;
      const baseTotal  = baseUnitPrice * selOpt.qty;
      const otpSavings = baseTotal - otpTotal;
      const showOtp    = otpSavings > 0.01;

      document.getElementById("pc-otp-total").textContent = fmt(otpTotal);
      const otpCompare   = document.getElementById("pc-otp-compare");
      const otpSavingsEl = document.getElementById("pc-otp-savings");
      if (otpCompare)   { otpCompare.textContent = showOtp ? fmt(baseTotal) : ""; otpCompare.style.display = showOtp ? "" : "none"; }
      if (otpSavingsEl) { otpSavingsEl.textContent = showOtp ? fmt(otpSavings) : ""; otpSavingsEl.parentElement.style.display = showOtp ? "" : "none"; }
      document.getElementById("pc-sub-compare").textContent = fmt(otpTotal);
      document.getElementById("pc-sub-total").textContent   = fmt(subTotal);
      document.getElementById("pc-sub-savings").textContent = fmt(subSavings);
      freqSelect.innerHTML = freqHtml(selOpt);
    }

    function selectNativeVariant(id) {
      const productSection = document.querySelector('.product-single__form, form[action*="/cart/add"].product-single__form');
      const scope = productSection || document;
      scope.querySelectorAll('select[name="id"]').forEach(el => {
        for (let i = 0; i < el.options.length; i++) {
          if (el.options[i].value === id) { el.options[i].selected = true; el.dispatchEvent(new Event("change", {bubbles:true})); break; }
        }
      });
      scope.querySelectorAll('input[name="id"]').forEach(el => {
        el.value = id; el.dispatchEvent(new Event("change", {bubbles:true}));
      });
    }

    function setMode(mode) {
      if (mode === currentMode) return;
      currentMode = mode;
      root.setAttribute("data-mode", mode);
      otpBlock.classList.toggle("is-selected", mode === "otp");
      subBlock.classList.toggle("is-selected", mode === "sub");
      freqWrap.style.display = mode === "sub" ? "block" : "none";
      animateList();
      syncState();
    }

    function selectSize(idx) {
      selIdx = idx;
      selOpt = opts[idx];
      root.querySelectorAll(".pc-size-card").forEach((c, i) => c.classList.toggle("current", i === idx));
      if (isGround) setVariantIdInUrl(selOpt.variantId);
      updatePrices();
      selectNativeVariant(selOpt.variantId);
      syncState();
    }

    otpBlock.addEventListener("click", () => { setMode("otp"); selectNativeVariant(selOpt.variantId); });
    subBlock.addEventListener("click", () => { setMode("sub"); selectNativeVariant(selOpt.variantId); });
    freqSelect.addEventListener("change", () => syncState());

    root.querySelectorAll(".pc-size-card").forEach(card => {
      card.addEventListener("click", e => {
        e.stopPropagation();
        selectSize(parseInt(card.getAttribute("data-option-index"), 10));
      });
    });

    // form submit intercept
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      form.addEventListener("submit", () => {
        window._pc09Submitting = true;
        const idSel = form.querySelector('select[name="id"]');        if (idSel) {
          for (let i = 0; i < idSel.options.length; i++) {
            if (idSel.options[i].value === selOpt.variantId) { idSel.options[i].selected = true; break; }
          }
        }
        let sp = form.querySelector('input[name="selling_plan"]');
        if (!sp) { sp = document.createElement("input"); sp.type="hidden"; sp.name="selling_plan"; form.appendChild(sp); }
        sp.value = currentMode === "sub" && freqSelect.value ? freqSelect.value.split(":")[0] : "";
        let qty = form.querySelector('input[name="quantity"]');
        if (!qty) { qty = document.createElement("input"); qty.type="hidden"; qty.name="quantity"; form.appendChild(qty); }
        qty.value = String(selOpt.qty);
        setTimeout(() => { window._pc09Submitting = false; }, 500);
      }, true);
    });

    selectNativeVariant(selOpt.variantId);
    syncState();

    // Skio Shadow DOM sync
    waitForElement("skio-plan-picker").then(pp => {
      waitUntil(() => !!(
        pp.shadowRoot &&
        pp.shadowRoot.querySelector("select.selling-plan-dropdown") &&
        pp.shadowRoot.querySelector("select.selling-plan-dropdown").options.length > 0
      )).then(() => {
        const skioDrop     = pp.shadowRoot.querySelector("select.selling-plan-dropdown");
        const skioSubRadio = pp.shadowRoot.querySelector('[id*="group-0-skio_plan_picker_"]');
        const skioOtpRadio = pp.shadowRoot.querySelector('[id*="one-time-skio_plan_"]');

        function syncSkioPlan(planId) {
          for (let i = 0; i < skioDrop.options.length; i++) {
            if (skioDrop.options[i].value === planId) {
              skioDrop.options[i].selected = true;
              skioDrop.dispatchEvent(new Event("change", {bubbles:true}));
              break;
            }
          }
        }

        function hideIrrelevantPlans() {
          const valid = selOpt.sellingPlanIds || [];
          for (let i = 0; i < skioDrop.options.length; i++) {
            skioDrop.options[i].hidden = !valid.includes(skioDrop.options[i].value);
          }
        }

        function applyToSkio() {
          selectNativeVariant(selOpt.variantId);
          if (currentMode === "otp") {
            if (skioOtpRadio) { skioOtpRadio.checked = true; skioOtpRadio.dispatchEvent(new Event("change", {bubbles:true})); }
          } else {
            if (skioSubRadio) { skioSubRadio.checked = true; skioSubRadio.dispatchEvent(new Event("change", {bubbles:true})); }
            const fv = freqSelect.value;
            if (fv) syncSkioPlan(fv.split(":")[0]);
          }
          hideIrrelevantPlans();
        }

        otpBlock.addEventListener("click", applyToSkio);
        subBlock.addEventListener("click", applyToSkio);
        freqSelect.addEventListener("change", () => {
          const fv = freqSelect.value;
          if (fv) syncSkioPlan(fv.split(":")[0]);
          syncState();
        });

        hideIrrelevantPlans();
        applyToSkio();
      });
    });

  });

};

console.log("[PC-09] Ready.");

// =============================================================================
// PUR-10 — "Ships Free" badge on size cards over $60
// =============================================================================
window.activatePC10 = function activatePC10() {
  if (window._pc10Active) {
    console.log("[PC-10] Already activated. Skipping.");
    return;
  }
  window._pc10Active = true;

  const SHIPS_FREE_THRESHOLD = 60;

  const style = document.createElement("style");
  style.id = "pc-ships-free-styles";
  style.textContent = `
    .pc-size-item .pc-size-card {
      padding-bottom: 12px;
    }
    .pc-size-card.ships-free:after {
      content: "Ships Free";
      position: absolute;
      bottom: -9px;
      left: 50%;
      transform: translateX(-50%);
      background: #00998d;
      color: white;
      font-size: 10px;
      font-weight: 800;
      padding: 1px 6px;
      border-radius: 3px;
      white-space: nowrap;
      line-height: 1.6;
      letter-spacing: 0.3px;
    }
  `;

  document.head.appendChild(style);

  function applyShipsFree() {
    document.querySelectorAll(".pc-size-card").forEach(card => {
      const idx = parseInt(card.getAttribute("data-option-index"), 10);
      const optionIndex = isNaN(idx) ? -1 : idx;
      const priceEl = card.querySelector(".pc-price-otp, .pc-price-sub");
      const total = parseFloat(card.getAttribute("data-otp-total") || "0");

      card.classList.toggle("ships-free", total >= SHIPS_FREE_THRESHOLD);
    });
  }

  waitUntil(() => {
    const cards = document.querySelectorAll(".pc-size-card");
    return cards.length > 0 && cards[0].hasAttribute("data-otp-total");
  }).then(() => {
    applyShipsFree();

    const observer = new MutationObserver(applyShipsFree);
    const sizeList = document.querySelector(".pc-sizes-list");
    if (sizeList) {
      observer.observe(sizeList, { childList: true, subtree: true, attributes: true, attributeFilter: ["data-otp-total"] });
    }
  });

};

console.log("[PC-10] Ready.");

//
// START PP Logic
//
const push_pp_offers = () => {
  if(window.sessionStorage.getItem("Proteus pp-session-id") && window.cart_pp_offers.length > 0){

    // window.cart_pp_offers = [];
    if(window.location.href.indexOf("new_pp") > -1){
      window.cart_pp_offers = window.cart_pp_offers_new
    }

    let session_id = window.sessionStorage.getItem("Proteus pp-session-id");
    fetch("https://proteus-puritycoffee.fly.dev/api/pp_offers", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
        referenceId: session_id,
        offers: window.cart_pp_offers
      })
    }).then(res => res.json()).then(console.log).catch(console.error);

  }
};

waitUntil(() => {
  return typeof window.cart_pp_offers != "undefined" && window.cart_pp_offers.length > 0;
}).then(() => {

  if(!window.sessionStorage.getItem("Proteus pp-session-id")){
    let pp_session_id = "pp-";
    for (let i = 0; i < 16; i++) {
      pp_session_id += Math.floor(Math.random() * 10);
    }
    window.sessionStorage.setItem("Proteus pp-session-id", pp_session_id)
    setTimeout(() => {
      gtm_add_cartAttribute("pp-session-id", pp_session_id);
    }, 2500); // delay to reduce API clogging
  }

  push_pp_offers();

}).catch();

async function get_proteus_product_data(prod_ids) {
  console.log("get_proteus_product_data()");

  // could potentially do this via Shopify REST API
  const response = await fetch(`https://proteus-puritycoffee.fly.dev/api/catalog?lookup=product_offers&ids=${prod_ids}`);

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }

  const data = await response.json();
  return data;
}

document.addEventListener("proteus:cart-changed", async (e) => {

  console.log("proteus: cart updated", e.detail);

  window.cart_data = e.detail;

  // add.js returns a line item instead of full cart
  if (!window.cart_data?.items) {
    try {
      const res = await fetch("/cart.js");
      window.cart_data = await res.json();
    } catch (err) {
      console.error("failed to normalize cart", err);
      return;
    }
  }

  let cart_prod_ids = [];
  for(let i = 0; i < cart_data.items.length; i++){
    cart_prod_ids.push(cart_data.items[i].product_id);
  }

  // no check if no ids
  if (!cart_prod_ids?.length) return;

  get_proteus_product_data(cart_prod_ids.toString()).then(response => {
    console.log("get_proteus_product_data", response)
    window.staged_pp_offers = response.offers;
    
    window.cart_pp_offers = [];
    for(let i = 0; i < window.staged_pp_offers.length; i++){

      window.cart_pp_offers.push({

        pp_offer_type: window.staged_pp_offers[i].def_type,
        pp_offer_new_qty: window.staged_pp_offers[i].def_quantity,
        pp_offer_new_interval: window.staged_pp_offers[i].ref_new_interval,
        pp_offer_id: window.staged_pp_offers[i].def_offer_id,
        pp_offer_banner_title: window.staged_pp_offers[i].content_banner_title,
        pp_offer_banner_subtitle: window.staged_pp_offers[i].content_banner_subtitle,
        pp_offer_title: window.staged_pp_offers[i].content_title,
        pp_offer_image_url: window.staged_pp_offers[i].content_images[0],
        pp_offer_description: [window.staged_pp_offers[i].content_description],
        pp_offer_compare_at: window.staged_pp_offers[i].content_compare_at,
        pp_offer_price: window.staged_pp_offers[i].content_offer_price,
        changes: window.staged_pp_offers[i].changes,

      });

    }

    push_pp_offers();
  
  });
});

//
// END PP Logic
//

//
// START [PUR-20]
//

document.addEventListener("proteus:cart-changed", async (e) => {
  if(window.sessionStorage.getItem("[PUR-20] active")){

    const cart_contains_decaf = e.detail.items.some(obj =>
      obj.product_title?.toLowerCase().includes("decaf")
    );

    proteus.add_cartAttribute("proteus_checkout_option", "[PUR-20] v1")

    if(cart_contains_decaf){
      proteus.add_cartAttribute("proteus_checkout_upsell", "[PUR-20] decaf")
    } else {
      proteus.add_cartAttribute("proteus_checkout_upsell", "[PUR-20] coffee")
    }

  }
});

//
// END [PUR-20]
//

function in_fathers_day_time_window() {
  const now = new Date();

  const start = new Date("2026-06-15T10:00:00-04:00"); // Jun 15, 10:00 AM EDT
  const end   = new Date("2026-06-21T23:59:59-04:00"); // Jun 21, 11:59:59 PM EDT

  return now >= start && now <= end;
}

/* START Father's Day promo */
if(window.fd_gwp_is_available && (
    window.location.href.indexOf("fathers_day_promo") > -1 ||
    window.sessionStorage.getItem("fathers day promo") ||
    in_fathers_day_time_window()
  )
){

  window.sessionStorage.setItem("fathers day promo", true);

  waitForElement('.drawer__message').then(cart_message => {
    cart_message.innerHTML = `Free gift on orders $125+, while supplies last`;
    cart_message.insertAdjacentHTML("beforebegin", `
      <style>
      .cart__item[data-prod-id="47141726879913"] .cart__discount{
        display: block;
      }
      </style>  
    `);
  }).catch();

  const review_cart_fd = () => {

    console.log("review_cart_fd()");

    waitUntil(() => {
      return window?.cart_data?.items;
    }).then(() => {

      let discount_attribute = "fathers_day_promo";

      let fd_threshold_met = window.cart_data.total_price >= 12500;
      // let fd_gwp_var_id = 36368188309671; // calm sachet
      let fd_gwp_var_id = 47141726879913; // healthy dad club mug
      let cart_has_fd_gwp = window.cart_data.items.some(function(item) { return item.variant_id == fd_gwp_var_id; })

      window.fd_gwp_attempted = window.fd_gwp_attempted || false;
      window.fd_gwp_running = window.fd_gwp_running || false;
      window.fd_gwp_added_this_pageload = window.fd_gwp_added_this_pageload || false;

      if (
        !window.fd_gwp_attempted &&
        !window.fd_gwp_running &&
        // window.cart_data?.attributes?._proteus_discount_1 != discount_attribute &&
        !window.fd_gwp_added_this_pageload &&
        fd_threshold_met
      ) {
        
        window.fd_gwp_running = true;
        window.fd_gwp_attempted = true;
        window.fd_gwp_added_this_pageload = true;

        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            attributes: {
              _proteus_discount_1: discount_attribute
            }
          })
        }).then(() => {

          if (!cart_has_fd_gwp) {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                items: [{
                  id: fd_gwp_var_id,
                  quantity: 1,
                  properties: {
                    _proteus_discount_1: discount_attribute
                  }
                }]
              })
            });
          }

        }).then(() => {
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:build', {
              bubbles: true
            })
          );
        }).finally(() => {
          window.fd_gwp_running = false;
        });

      } // run only once

    }).catch();
  } // review_cart_fd()

  // init 
  review_cart_fd();

 document.addEventListener("proteus:cart-changed", () => {

  setTimeout(() => {
    review_cart_fd();
  }, 500)
 }) 

}